require("../../vendor/stickyfill.js");

var Promise = require('es6-promise').Promise;
var compose = require('lodash.compose');
var curry = require('curry');

var getItemPoint = require('./fn/getItemPoint.js');
var getImagePromise = require('./fn/getImagePromise.js');
var selectItem = require('./fn/selectItem.js');
var addMarkerToMap = curry(require('./fn/addMarkerToMap.js'));
var loadRegionsToMap = curry(require('./fn/loadRegionsToMap.js'));
var bindItemClickHandler = curry(require('./fn/bindItemClickHandler.js'));

module.exports = function(root) {
	if(!root) {
		return;
	}

	var mapEl = root.querySelector('.contacts__map');

	ymaps.ready(() => {
		var map = new ymaps.Map(mapEl, {
			center: [mapEl.dataset.lat, mapEl.dataset.lng],
			zoom: 3
		});

		map.controls.add('zoomControl');
		Promise.all(Array.prototype.map.call(
			root.querySelectorAll('.contacts__item'),
			compose(getImagePromise, getItemPoint)
		))
		.then(loadRegionsToMap(map))
		.then((items) => items.map(bindItemClickHandler(map)))
		.then((items) => items.map(addMarkerToMap(map)));
	})

	window.Stickyfill.add(mapEl);
	Array.prototype.forEach.call(root.querySelectorAll('.contacts__title'), window.Stickyfill.add);

	$('.js-contacts').click(function() {
		$(this).parent('.contacts-extra').toggleClass('st-active');
	})
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/index.js
 **/